import { getMesAvancoDataAtual } from "./Data.js";

const getOptionsDataPrevisaoativacao = () => {
  return [
    { value: 'SD', text: 'Sem data' },
    { value: 'VC', text: 'Vencido' },
    { value: 5, text: 'a vencer 5 dias' },
    { value: 'MA', text: 'a vencer '+getMesAvancoDataAtual(0) },
    { value: 'M1', text: 'a vencer '+getMesAvancoDataAtual(1) },
    { value: 'M2', text: 'a vencer '+getMesAvancoDataAtual(2) },
    { value: 'MM2', text: 'a vencer > '+getMesAvancoDataAtual(2) },
  ]
}  

const getOptionsPrevisaoEntregaAcesso = () => {
  return [
    { value: 'SD', text: 'Sem data' },
    { value: 'VC', text: 'Vencido' },
    { value: 5, text: 'a vencer 5 dias' },
    { value: 'MA', text: 'a vencer '+getMesAvancoDataAtual(0) },
    { value: 'M1', text: 'a vencer '+getMesAvancoDataAtual(1) },
    { value: 'M2', text: 'a vencer '+getMesAvancoDataAtual(2) },
    { value: 'MM2', text: 'a vencer > '+getMesAvancoDataAtual(2) },
  ]
}  

const getOptionsTempoAExpirar = () => {
  return [
    { value: 'VC', text: 'Vencido' },
    { value: 'HJ', text: 'Hoje' },
    { value: 5, text: 'a vencer 5 dias' },
    { value: 10, text: 'a vencer 10 dias' },
    { value: 15, text: 'a vencer 15 dias' },
    { value: 20, text: 'a vencer 20 dias' },
  ] 
}

const getParametrosVaziosFiltrosTarefas = () => {
  return {
    item: { 
      ctrlMacroProcessoId: null,
      ctrlProcessoId: null,
      ctrlTarefaId: null,
      emAtendimento: null,
      interrompida: null,
      emCancelamento: null,
      aging: null,
      flagInterrupcao: null,
      ctrlFamiliaId: null
    }  
  };
}

const getRegionaisDoUsuario = () => {
  let sessao = JSON.parse(localStorage.getItem("sgp-usuario"));
  return sessao.regionais;
}


  export {
    getMesAvancoDataAtual,
    getOptionsDataPrevisaoativacao,
    getOptionsPrevisaoEntregaAcesso,
    getOptionsTempoAExpirar,
    getParametrosVaziosFiltrosTarefas,
    getRegionaisDoUsuario
  }